import React, { useEffect, useState } from 'react'
import SummaryOfRiskChart from './SummaryOfRiskChart'
import SummaryOfIssue from './SummaryOfIssue'
import SearchButton from '../../../components/buttons/searchButton/SearchButton'
import { Col, Panel, Row, SelectPicker } from 'rsuite'
import { getSummaryOfIssueSchema } from '../../../redux/actions/auditDashboard'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import { doneLoading, startLoading } from '../../../utils/loading'

export default function SummaryOfIssueWidget({ budgetYear, ...props }) {
  const { showLoading } = props

  const [schema, setSchema] = useState()
  const [request, setRequest] = useState()
  const [isRefash, setIsRefash] = useState(false)
  const [department, setDepartment] = useState()
  // const [isLoading, setIsLoading] = useState()
  // const [error, setError] = useState()

  useEffect(() => {
    console.log('budgetYear : ', budgetYear)

    setRequest({ budgetYear: budgetYear })
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    // setIsLoading(true)
    startLoading()
    try {
      const response = await getSummaryOfIssueSchema()
      setSchema(response)
      onRefash()
    } catch (e) {
      console.log('SummaryOfIssueWidget Error : ', e)

      // if (e?.response?.data) {
      //   setError({
      //     statusCode: e.response.data.status,
      //     errorMessage: e.response.data.errors?.message,
      //   })
      // } else {
      //   setError({})
      // }
    }
    doneLoading()
    // setIsLoading(false)
  }

  const handleSearch = (request) => {
    setRequest(request)
    onRefash()
  }
  const onCancle = () => {
    setDepartment('')
    handleSearch({ budgetYear: budgetYear })
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  return (
    <>
      <Panel
        header={schema?.header || 'จำนวนประเด็นที่พบตามสำนัก'}
        bordered
        collapsible
        defaultExpanded
        shaded
        style={{ marginTop: 20 }}
      >
        {schema?.searchForm && (
          <div style={{ marginTop: 0 }}>
            <Row style={{ marginTop: 10 }}>
              {schema.searchForm.department && (
                <>
                  <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                    {schema.searchForm.department.label}
                  </Col>
                  <Col lg={8} md={8} sm={24} xs={24}>
                    <SelectPicker
                      data={schema.searchForm.department.options}
                      value={department}
                      block
                      onChange={(value) => {
                        setDepartment(value)
                      }}
                    />
                  </Col>
                </>
              )}

              <Col lg={12} md={12} sm={24} xs={24}>
                <SearchButton
                  // disabled={loading}
                  onClick={() => {
                    handleSearch({ budgetYear: budgetYear, department: department })
                  }}
                  style={{ marginTop: 0, marginLeft: 0 }}
                />
                <CancelButton
                  onClick={onCancle}
                  style={{ marginTop: 0, marginLeft: 10 }}
                  children="ยกเลิก"
                />
              </Col>
            </Row>
          </div>
        )}

        {!isRefash && (
          <>
            {schema?.panels?.map((e) => {
              let panel

              switch (e) {
                case 'summaryOfRisk':
                  panel = <SummaryOfRiskChart request={request} />
                  break
                case 'summaryOfIssue':
                  panel = <SummaryOfIssue request={request} />
                  break
                default:
                  break
              }

              return panel
            })}
          </>
        )}
      </Panel>
    </>
  )
}
